import { KeyboardEventHandler, MouseEventHandler } from "react";
// Helpers
import { isNavigationKey } from "@/Washouts/components/tables/Finance/Managers/ProductConversionsTable/helpers";
// Materials
import { Box, IconButton } from "@mui/material";
import {
	gridFilteredDescendantCountLookupSelector,
	useGridApiContext,
	useGridSelector,
} from "@mui/x-data-grid-premium";
// Types
import { CustomGridTreeDataGroupingCellProps } from "@Layouts/components/types";
// Icons
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";

export function CustomGridTreeDataGroupingCell(props: Readonly<CustomGridTreeDataGroupingCellProps>) {
	const { id, field, rowNode } = props;

	const apiRefContext = useGridApiContext();
	const filteredDescendantCountLookup = useGridSelector(apiRefContext, gridFilteredDescendantCountLookupSelector);

	const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;

	const handleKeyDown: KeyboardEventHandler<HTMLElement> = (event) => {
		if (event.key === " ") {
			event.stopPropagation();
		}
		if (isNavigationKey(event.key) && !event.shiftKey) {
			// previously "cellNavigationKeyDown"
			apiRefContext.current.publishEvent("cellKeyDown", props, event);
		}
	};

	const handleClick: MouseEventHandler = (event) => {
		event.stopPropagation();
		apiRefContext.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
		apiRefContext.current.setCellFocus(id, field);
	};

	return (
		<Box>
			<div>
				{filteredDescendantCount > 0 ? (
					<IconButton
						className={ props.className ?? "size-[20px] !ml-[5px] relative !-top-[2px]"}
						aria-label="expand"
						onClick={handleClick}
						onKeyDown={handleKeyDown}
					>
						{!rowNode.childrenExpanded ? <ExpandMoreRoundedIcon /> : <ExpandLessRoundedIcon />}
					</IconButton>
				) : (
					<span />
				)}
			</div>
		</Box>
	);
}
